export enum FileSource {
    PAPER = 'PAPER', //listine
    DOCUMENT = 'DOCUMENT', //vse ostalo
}
//za locevanje listin in dokumentov pri klicanju preview API-ja
